import { render, staticRenderFns } from "./ModalCallback.vue?vue&type=template&id=07a01e53&scoped=true&"
import script from "./ModalCallback.vue?vue&type=script&lang=js&"
export * from "./ModalCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a01e53",
  null
  
)

export default component.exports